function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    margin-bottom: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n\n    &:not(:first-child) {\n      margin-top: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { Children, forwardRef } from "react";
import styled, { css } from "styled-components";
var MenuSectionWrapper = styled.div((_ref) => {
  var {
    hasTitle,
    theme
  } = _ref;
  return css(_templateObject(), hasTitle ? theme.spaceUnit.md : theme.spaceUnit.xxl);
});
var MenuSectionTitle = styled.span((_ref2) => {
  var {
    theme
  } = _ref2;
  return css(_templateObject2(), theme.spaceUnit.xs);
});

var MenuSection = (_ref3, ref) => {
  var {
    children,
    orientation = "horizontal",
    title
  } = _ref3;
  var itemWidth = orientation === "horizontal" ? 1 / Children.count(children) * 100 : 100;
  return /*#__PURE__*/React.createElement(MenuSectionWrapper, {
    hasTitle: !!title
  }, title && /*#__PURE__*/React.createElement(MenuSectionTitle, null, typeof title === "string" ? title : title()), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: orientation === "horizontal" ? "row" : "column"
    }
  }, Children.count(children) > 1 ? React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    orientation,
    ref,
    width: itemWidth
  })) : /*#__PURE__*/React.cloneElement(children, {
    orientation,
    ref,
    width: itemWidth
  })));
};

export default /*#__PURE__*/forwardRef(MenuSection);